export default {
  getMessage: {
    name: 'getMessage',
  },
  getMeetings: {
    name: 'getMeetings',
  },
  getAvailabilities: {
    name: 'getAvailabilities'
  },
  getThreads: {
    name: 'getThreads',
  },
  getThreadParticipants: {
    name: 'getThreadParticipants',
  },
  getSearchResults: {
    name: 'getSearchResults',
  },
  getLeadCaptures: {
    name: 'getLeadCaptures'
  },
  getEscalatedHouseholds: {
    name: 'getEscalatedHouseholds'
  },
  getCalendarEvents: {
    name: 'getCalendarEvents'
  },
  getEndpointDefinition: {
    name: 'getEndpointDefinition',
  },
  getDevOnlyHouseholdInfos: {
    name: 'getDevOnlyHouseholdInfos'
  },
  householdActiveTasks: {
    name: 'householdActiveTasks',
  },
  householdHiddenTasks: {
    name: 'householdHiddenTasks',
  },
  getCashFlow: {
    name: 'getCashFlow'
  },
  getCashFlowTransactions: {
    name: 'getCashFlowTransactions'
  },
  getAvailabilityPeriods: {
    name: 'getAvailabilityPeriods'
  },
  getFacetPlanView: {
    name: 'getFacetPlanView'
  },
  getManagedAccountActivity: {
    name: 'getManagedAccountActivity'
  },
  getFacetPlanChartData: {
    name: 'getFacetPlanChartData'
  },
  getAccountActivitySummaries: {
    name: 'getAccountActivitySummaries'
  },
  getBenchmarkedPerformance: {
    name: 'getBenchmarkedPerformance'
  },
  getClearingHouseAccountDocuments: {
    name: 'getClearingHouseAccountDocuments'
  },
  getFacetPlanMultiChartData: {
    name: 'getFacetPlanMultiChartData'
  },
  getFQTmplQuiz: {
    name: 'getFQTmplQuiz',
  },
  getFQTmplQuestion: {
    name: 'getFQTmplQuestion',
  },
  getFQTmplQuestionAdminTableRows: {
    name: 'getFQTmplQuestionAdminTableRows',
  }
};
